import { redirect, Outlet, useNavigation } from "react-router-dom";
import type { LoaderFunctionArgs } from "react-router-dom";

export async function loader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  try {
    const res = await fetch("/api/sso/profile", {
      credentials: "include",
      headers: { Accept: "application/json" },
    });
    if (!res.ok) {
      const returnParam = encodeURIComponent(url.pathname + url.search);
      throw redirect(`/login?return=${returnParam}`);
    }
    const user = await res.json();
    return { user };
  } catch (err) {
    if (err instanceof Response) throw err;
    const returnParam = encodeURIComponent(url.pathname + url.search);
    throw redirect(`/login?return=${returnParam}`);
  }
}

export function ProtectedRoute() {
  const navigation = useNavigation();
  const isLoading = navigation.state === "loading";

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-muted-foreground">Carregando...</p>
      </div>
    );
  }

  return <Outlet />;
}

ProtectedRoute.loader = loader;
